import React, { useEffect, useState, useMemo } from 'react';
import Container from '@/components/container';
import './index.less';
import { Divider, Form, Input, Select, message, Modal, Row, Col, Button } from 'antd';
import FixFooterWrapper from '@/components/fix-footer-wrapper';
import { CREATE_TYPE } from '../../data';
import UploadPic from '@/components/upload-pic';
import AddChannelDetailInfo from './add-channel-detail-info';
import ListTowerModal from './list-tower-modal';
import { goto } from '@/common/utils';
import env from '@/env';
import apis from '../../apis';
import { useHistory } from 'react-router-dom';

const { Option } = Select;
const { TextArea } = Input;

const ChannelForm = (props) => {
  const history = useHistory();
  const [towerInfo, setTowerInfo] = useState({});
  const [visible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { initialValue } = props;
  // const isEdit = !!initialValue.channelId;
  const isEdit = useMemo(() => !!initialValue.channelId, [initialValue.channelId]);
  const [form] = Form.useForm();
  const onFinish = (val) => {
    if (!towerInfo.towerId) {
      message.warning('请关联通天塔项目');
      return;
    }
    setShowModal(true);
  };
  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({ ...initialValue });
      setTowerInfo(initialValue);
    }
  }, [initialValue, form, isEdit]);

  const getApi = () => {
    if (isEdit) return apis.channelMicroUpdateChannel;
    return apis.channelMicroAddChannel;
  };

  const submitForm = useMemo(() => {
    if (isEdit) return apis.channelMicroUpdateChannel;
    return apis.channelMicroAddChannel;
  }, [isEdit]);

  const channelMicroAddChannel = (submit) => {
    const value = form.getFieldValue();
    submitForm({
      ...value,
      templetId: towerInfo.templetId,
      towerId: towerInfo.towerId,
      pageId: towerInfo.pageId,
      submit,
    }).then((res) => {
      const { ret, msg } = res;
      if (ret === '0') {
        setShowModal(false);
        history.push('/channel-micro/my-manager');
      } else {
        message.error(msg);
      }
    });
  };

  return (
    <Container>
      <div className="channel-micro-add-channel-title">{isEdit ? '编辑' : '新建'}微频道</div>
      <Form form={form} onFinish={onFinish} layout="vertical" style={{ paddingBottom: '64px' }}>
        <div className="add-channel-baseinfo-title">微频道基本信息</div>
        <Divider className="channel-micro-add-channel-line" />
        <Row gutter={80}>
          <Col span={8}>
            <Form.Item
              label="微频道名称:"
              name="name"
              rules={[
                {
                  required: true,
                  message: '微频道名称不能为空',
                },
                {
                  max: 8,
                  message: '微频道名称不能超过8个字符',
                },
              ]}
            >
              <Input placeholder="请输入" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="建场方式:"
              name="createType"
              initialValue={1}
              rules={[
                {
                  required: true,
                  message: '建场方式不能为空',
                },
              ]}
            >
              <Select allowClear disabled>
                {CREATE_TYPE.map((item) => (
                  <Option value={item.val} key={item.val}>
                    {item.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={80}>
          <Col span={8}>
            <Form.Item
              label="微频道简介:"
              name="remark"
              rules={[
                {
                  required: true,
                  message: '微频道名称不能为空',
                },
                {
                  max: 40,
                  message: '频道简介不能超过40个字符',
                },
              ]}
            >
              <TextArea rows={4} placeholder="请填写微频道运营策略及覆盖人群" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="pic"
              help={<div style={{ color: '#FEB00E' }}> 200pxX200px,40k以内，JPG、PNG格式</div>}
              label={
                <div>
                  微频道图片
                  <span style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)', marginLeft: '6px' }}>
                    配置可能会在我京等流量场露出
                  </span>
                </div>
              }
            >
              <UploadPic checkParams={{ height: 200, width: 200, max: 40 }} accept="image/*" />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '50px' }}>
          <div className="add-channel-baseinfo-title">微频道页面配置</div>
          {!towerInfo.towerId ? (
            <Button
              type="primary"
              shape="round"
              style={{ marginLeft: '16px' }}
              onClick={() => {
                setVisible(true);
              }}
            >
              关联通天塔项目
            </Button>
          ) : (
            <>
              <Button
                style={{ marginLeft: '16px', marginRight: '8px' }}
                type="primary"
                shape="round"
                ghost
                onClick={() => {
                  goto(towerInfo.towerPageLink, true);
                }}
              >
                预览页面
              </Button>
              <Button
                style={{ marginRight: '8px' }}
                type="primary"
                shape="round"
                ghost
                onClick={() => {
                  towerInfo.advertId &&
                    window.open(
                      `/batch-micro#/integration/batchcreate?isMicroChannel=1&origin=yx&advertGroupId=${towerInfo.advertId}&editFlag=1`,
                      '_blank',
                      'noopener'
                    );
                }}
              >
                编辑页面
              </Button>
              <a
                onClick={() => {
                  setVisible(true);
                }}
              >
                更换通天塔项目
              </a>
            </>
          )}
        </div>
        <Divider />
        {towerInfo.towerId && <AddChannelDetailInfo towerInfo={towerInfo} />}

        <FixFooterWrapper leftSpace={0} rightSpace={0}>
          <Button
            shape="round"
            onClick={() => {
              form
                .validateFields()
                .then((res) => {
                  if (!towerInfo.towerId) {
                    message.warning('请关联通天塔项目');
                    return;
                  }
                  channelMicroAddChannel(0);
                })
                .catch((err) => {});
            }}
          >
            保存
          </Button>
          <Button shape="round" type="primary" htmlType="submit">
            提交审核
          </Button>
        </FixFooterWrapper>
      </Form>

      <ListTowerModal visible={visible} setVisible={setVisible} setTowerInfo={setTowerInfo} />

      <Modal
        title="确认提交审核吗"
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onOk={() => {
          channelMicroAddChannel(1);
        }}
      >
        <div>提交后将由您的直属上级进行微频道入驻审批。</div>
      </Modal>
    </Container>
  );
};
export default ChannelForm;
